import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_5 = { class: "container p-0" }
const _hoisted_6 = { class: "row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Input", -1)
const _hoisted_8 = { class: "row mb-10" }
const _hoisted_9 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_10 = { class: "card card-flush" }
const _hoisted_11 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_12 = { class: "container p-0" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "row mb-5" }
const _hoisted_15 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}, "Response", -1)
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                id: "exampleFormControlInput1",
                class: "form-control form-control-solid",
                placeholder: "Tell me what do you want to know ?",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.playground) = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.playground]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.requestNewAdvert && _ctx.requestNewAdvert(...args))),
                class: "btn btn-primary"
              }, "Submit")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.advert.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("textarea", {
                        type: "text",
                        id: "exampleFormControlInput1",
                        class: "form-control form-control-solid",
                        placeholder: "Title",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.advert[0].response) = $event)),
                        rows: "25",
                        "max-rows": "20"
                      }, null, 512), [
                        [_vModelText, _ctx.advert[0].response]
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, "Fill the Form and Submit to receive a response"))
          ])
        ])
      ])
    ])
  ]))
}